import { render, staticRenderFns } from "./flex-scroll.vue?vue&type=template&id=60443cf0&"
import script from "./flex-scroll.vue?vue&type=script&lang=ts&"
export * from "./flex-scroll.vue?vue&type=script&lang=ts&"
import style0 from "./flex-scroll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports